export default class LocaleMonth {

 static srMonth(date){
   let result ='';
   switch(date){
       case '01':
        result = 'januar';
       break;
       case '02':
        result = 'februar';

        break;
     case '03':
        result = 'mart';

       break;
       case '04':
        result = 'april';

        break;
        case '05':
            result = 'maj';

     break; 
     case '06':
        result = 'jun';

     break; 
     case '07':
        result = 'jul';

     break;
     case '08':
        result = 'avgust';

    break;
    case '09':
        result = 'septembar';

   break;
   case '10':
    result = 'oktobar';

 break;
 case '11':
    result = 'novembar';

    break;
    case '12':
        result = 'decembar';

        break;

   }
return result;
}
   static enMonth(date){
   let result ='';
   switch(date){
       case '01':
        result = 'january';
       break;
       case '02':
        result = 'february';

        break;
     case '03':
        result = 'march';

       break;
       case '04':
        result = 'april';

        break;
        case '05':
            result = 'may';

     break; 
     case '06':
        result = 'june';

     break; 
     case '07':
        result = 'july';

     break;
     case '08':
        result = 'august';

    break;
    case '09':
        result = 'september';

   break;
   case '10':
    result = 'october';

 break;
 case '11':
    result = 'november';

    break;
    case '12':
        result = 'december';

        break;

   }
return result;
}    
  
      
  static hrMonth(date){
   let result ='';
   switch(date){
       case '01':
        result = 'siječanj';
       break;
       case '02':
        result = 'veljača';

        break;
     case '03':
        result = 'ožujak';

       break;
       case '04':
        result = 'travanj';

        break;
        case '05':
            result = 'sviban';

     break; 
     case '06':
        result = 'lipanj';

     break; 
     case '07':
        result = 'srpanj';

     break;
     case '08':
        result = 'kolovoz';

    break;
    case '09':
        result = 'rujan';

   break;
   case '10':
    result = 'listopad';

 break;
 case '11':
    result = 'studeni';

    break;
    case '12':
        result = 'prosinac';

        break;

   }
return result;
}     


}
